class PrepaidOffer extends HTMLElement {
  connectedCallback() {
    const raw = this.querySelector('[data-prepaid-json]');
    if (!raw) return;

    const data = JSON.parse(raw.textContent);
    this.discount = data.discount;
    this.currencySymbol = data.currency_symbol;
    this.amountEl = this.querySelector('.prepaid-offer__amount');
    this.badgeEl = this.querySelector('.prepaid-offer__badge');

    // Render the initial price (single/default variant) on page load.
    // Pack-selector takes over and calls applyBanner() directly whenever the pack changes.
    this.updateDisplay(data.initial_price);
  }

  updateDisplay(priceInPaise) {
    const price = priceInPaise / 100;
    const discounted = Math.floor(price * (1 - this.discount / 100));
    const saved = price - discounted;
    const fmt = (n) => this.currencySymbol + n.toLocaleString('en-IN');
    if (this.amountEl) this.amountEl.textContent = fmt(discounted);
    if (this.badgeEl) this.badgeEl.textContent = `(${this.discount}% OFF)`;
  }
}

customElements.define('prepaid-offer', PrepaidOffer);
